import request from '@/utils/request'


/**
 * 登录
 * @param {array} data 请求数据
 */
export function postLogin(data) {
  return request({
    url: '/api/account/login',
    method: 'post',
    data
  })
}
// ===============================
/**
 * 获取项目
 * @param {array} params 请求数据
 */
export function getProject(params) {
  return request({
    url: '/api/project',
    method: 'get',
    params
  })
}

/**
 * 删除项目
 * @param {array} params 请求数据
 */
export function delProject(params) {
  return request({
    url: '/api/project/delete',
    method: 'delete',
    params
  })
}

/**
 * 新增项目
 * @param {array} data 请求数据
 */
export function postProject(data) {
  return request({
    url: '/api/project/save',
    method: 'post',
    data
  })
}

/**
 * 修改项目
 * @param {array} data 请求数据
 */
export function putProject(data) {
  return request({
    url: '/api/project/update',
    method: 'put',
    data
  })
}
// ================================


/**
 * 获取卡密列表
 * @param {array} params 请求数据
 */
export function getCard(params) {
  return request({
    url: '/api/card',
    method: 'get',
    params
  })
}

/**
 * 新增卡密
 * @param {array} data 请求数据
 */
export function postCard(data) {
  return request({
    url: '/api/card/save',
    method: 'post',
    data
  })
}

/**
 * 删除卡密
 * @param {array} params 请求数据
 */
 export function delCard(params) {
  return request({
    url: '/api/card/delete',
    method: 'delete',
    params
  })
}

// ==================================
/**
 * 获取日志
 * @param {array} params 请求数据
 */
 export function getLog(params) {
  return request({
    url: '/api/user/log',
    method: 'get',
    params
  })
}

/**
 * 获取更换记录
 * @param {array} params 请求数据
 */
 export function getReplaceLog(params) {
  return request({
    url: '/api/user/replace',
    method: 'get',
    params
  })
}

/**
 * 获取全部人员
 * @param {array} params 请求数据
 */
 export function getUserAll(params) {
  return request({
    url: '/api/user/all',
    method: 'get',
    params
  })
}

/**
 * 获取会员信息
 * @param {array} params 请求数据
 */
export function getUser(params) {
  return request({
    url: '/api/user',
    method: 'get',
    params
  })
}

/**
 * 修改信息
 * @param {array} data 请求数据
 */
 export function putUser(data) {
  return request({
    url: '/api/user/update',
    method: 'put',
    data
  })
}

/**
 * 修改密码
 * @param {array} data 请求数据
 */
 export function putPwd(data) {
  return request({
    url: '/api/user/pwd',
    method: 'put',
    data
  })
}

/**
 * 添加管理员
 * @param {array} data 请求数据
 */
 export function postUser(data) {
  return request({
    url: '/api/user/save',
    method: 'post',
    data
  })
}
// ==============================

/**
 * 获取验证码
 * @param {array} params 请求数据
 */
export function getCode(data) {
  return request({
    url: '/api/index/code',
    method: 'post',
    data
  })
}
/**
 * 在线授权
 * @param {array} data 请求数据
 */
 export function postOnline(data) {
  return request({
    url: '/api/index/online',
    method: 'post',
    data
  })
}

/**
 * 下载源码
 * @param {array} params 请求数据
 */
export function getDown(params) {
  return request({
    url: '/api/index/down',
    method: 'get',
    params
  })
}

/**
 * 更换授权
 * @param {array} data 请求数据
 */
 export function putReplace(data) {
  return request({
    url: '/api/index/replace',
    method: 'put',
    data
  })
}

/**
 * 查询授权
 * @param {array} params 请求数据
 */
 export function getQuery(params) {
  return request({
    url: '/api/index/query',
    method: 'get',
    params
  })
}

// ================================

/**
 * 授权项目
 * @param {array} params 请求数据
 */
 export function getAuth(params) {
  return request({
    url: '/api/auth',
    method: 'get',
    params
  })
}

/**
 * 删除授权
 * @param {array} params 请求数据
 */
export function delAuth(params) {
  return request({
    url: '/api/auth/delete',
    method: 'delete',
    params
  })
}

/**
 * 新增授权
 * @param {array} data 请求数据
 */
export function postAuth(data) {
  return request({
    url: '/api/auth/save',
    method: 'post',
    data
  })
}

/**
 * 修改授权
 * @param {array} data 请求数据
 */
export function putAuth(data) {
  return request({
    url: '/api/auth/update',
    method: 'put',
    data
  })
}